import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import Select from "react-select";
import { ItemType, SelectImageData } from "../../../utils/common";
import {  useLoader } from "../../../utils/common";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL ,setGlobalLoader} = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

const { loading, withLoader } = useLoader();
  const GetEditData = async () => {
    try {
      const response = await withLoader(() => getData(`/admin/masters/lens-type/${id}`));
      reset(response?.data);
    } catch (error) {
      console.error("Error fetching lens type data", error);
    } 
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("sort_order", data?.sort_order);
      sendData.append("item_type_id", ItemType.Lens);
      sendData.append("button_color", data?.button_color);
      sendData.append("background_color", data?.background_color);
      if (data?.image instanceof FileList && data.image.length > 0) {
        sendData.append("image", data?.image[0]);
      } else if (data?.gallery_image?.image[0]) {
        sendData.append("image", data?.gallery_image?.image);
      }
      const response = await withLoader(() => putData(
        `/admin/masters/lens-type/${id}`,
        sendData
      ));

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };






  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Lens Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>  
            <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
              <Row className="">
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <div className="">
                          <Form.Label>Lens Type</Form.Label>
                        </div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder="Type"
                            className={classNames("", {
                              "is-invalid": errors?.name,
                            })}
                            {...register("name", {
                              required: "Name is required",
                              validate: (value) =>
                                value.length <= 200 ||
                                "Data must be 200 characters or less",
                            })}
                          />
                        </InputGroup>
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>


                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Image</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="file"
                          name="image"
                          placeholder="Image"
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          {...register("image")}
                          accept="image/*"

                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>

                  <div className="main-form-section mt-3">
                    {typeof getValues("image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </div>
                </Col>


                <Row className="mt-5 pb-3">
                  <div className="d-flex justify-content-center">
                    <Link>
                      <CancelButton
                        name={"Cancel"}
                        handleClose={props.handleClose}
                      />
                    </Link>

                    <SaveButton
                      name={"Save"}
                      handleSubmit={handleSubmit(onSubmit)}
                    />
                  </div>
                </Row>
              </Row>
            </Form>
         
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
